module.exports = __webpack_public_path__ + "assets/img/img-fv.4c955de6.jpg";